import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Ссылка на связанное мероприятие  */
let PitActivityEntityLink = class PitActivityEntityLink {
    get dependentEntityCode() {
        return this._dependentEntityCode;
    }
    set dependentEntityCode(value) {
        this._dependentEntityCode = value;
    }
    get dependentEntityId() {
        return this._dependentEntityId;
    }
    set dependentEntityId(value) {
        this._dependentEntityId = value;
    }
    get dependentEntityName() {
        return this._dependentEntityName;
    }
    set dependentEntityName(value) {
        this._dependentEntityName = value;
    }
    get dependentEntityTypeId() {
        return this._dependentEntityTypeId;
    }
    set dependentEntityTypeId(value) {
        this._dependentEntityTypeId = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get entityLinkId() {
        return this._entityLinkId;
    }
    set entityLinkId(value) {
        this._entityLinkId = value;
    }
    get linkTypeId() {
        return this._linkTypeId;
    }
    set linkTypeId(value) {
        this._linkTypeId = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "dependentEntityCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityEntityLink.prototype, "_dependentEntityCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dependentEntityId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityLink.prototype, "_dependentEntityId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dependentEntityName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityEntityLink.prototype, "_dependentEntityName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dependentEntityTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityLink.prototype, "_dependentEntityTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityEntityLink.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "entityLinkId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityLink.prototype, "_entityLinkId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "linkTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityLink.prototype, "_linkTypeId", void 0);
PitActivityEntityLink = tslib_1.__decorate([
    jsonObject
], PitActivityEntityLink);
export { PitActivityEntityLink };
